import React from 'react'
import Grid from '@mui/material/Grid'
import GlobalIncomExpense from './charts/globalIncomeExpense'
import TherapistPerformance from './charts/therapistPerformance'

const Dashboard = () => {
    return (
        <Grid
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'space-between'}
        >
            <Grid sx={{ width: '50%', paddingRight: 1 }}>
                <TherapistPerformance />
            </Grid>
            <Grid sx={{ width: '50%', paddingLeft: 1 }}>
                <GlobalIncomExpense />
            </Grid>
        </Grid>
    )
}

export default React.memo(Dashboard)
